import React, { useState, useEffect } from 'react';
import { TextField, Grid, Button, CircularProgress, Alert, Box,
         Typography, MenuItem, Select,  FormControl, InputLabel, SelectChangeEvent } from '@mui/material';
import axios from 'axios';
import { get, post } from 'src/services/httpClient.service';

const API_URL = process.env.REACT_APP_BASE_API_URL;
//const API_URL = `${API_URL}/api/modules`;
//const VENDOR_API_URL = '/api/vendors';


// ✅ Define Props interface
interface AddModuleProps {
  handleClose: () => void;
  onSubmit?: () => void;
  fetchModulesData?: () => void;
}

const AddModule: React.FC<AddModuleProps> = ({ handleClose, onSubmit, fetchModulesData }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    prefix: '',
    sequence: '',
  });

  //const [vendors, setVendors] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

//    useEffect(() => {
//   const fetchVendors = async () => {
//     try {
//       const response = await get(`${APIURL}/api/vendors`, {
//         headers: { Accept: 'application/json, application/xml' },
//         responseType: 'text', // Allows parsing both JSON and XML
//       });

//       let vendorList: string[] = [];

//       try {
//         // Try to parse as JSON
//         const parsed = JSON.parse(response.data);
//         if (Array.isArray(parsed)) {
//           vendorList = parsed;
//         }
//       } catch {
//         // If JSON parsing fails, try XML
//         const parser = new DOMParser();
//         const xml = parser.parseFromString(response.data, 'application/xml');
//         const items = xml.getElementsByTagName('item');
//         vendorList = Array.from(items).map((el) => el.textContent || '');
//       }

//       setVendors(vendorList);
//     } catch (err) {
//       console.error('Error fetching vendors:', err);
//       setError('Failed to load vendors.');
//     }
//   };

//   fetchVendors(); // ✅ Call it here, outside the function definition
// }, [APIURL]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent<string>
  ) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name as string]: value as string,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const payload = {
        ...formData,
        sequence: parseInt(formData.sequence) || 0
      };

      const response = await post(`${API_URL}/api/modules`, payload);
      if (response.data) {
        setSuccess('Module created successfully!');
        setFormData({ name: '', description: '', prefix: '', sequence: ''});
        if (onSubmit) onSubmit(); // ✅ Call parent callback
        if (fetchModulesData) fetchModulesData(); // ✅ refresh list
        handleClose(); // ✅ close dialog
      }
    } catch (err: any) {
      console.error('Error creating module:', err);
      const errorMessage = err.response?.data?.message || 'Failed to create module';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({ name: '', description: '', prefix: '', sequence: ''});
    setError('');
    setSuccess('');
    handleClose(); // ✅ close on cancel too
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', p: 3 }}>
      <form onSubmit={handleSubmit}>
        {/* {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>} */}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              name="name"
              label="Module Name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              name="description"
              label="Description"
              value={formData.description}
              onChange={handleChange}
              fullWidth
              multiline
              rows={3}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              name="prefix"
              label="Prefix"
              value={formData.prefix}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              name="sequence"
              label="Sequence"
              type="number"
              value={formData.sequence}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

           {/* <Grid item xs={12}>
            <FormControl fullWidth required>
              <InputLabel>Vendor</InputLabel>
              <Select
                name="vendorId"
                value={formData.vendorId}
                onChange={(e: SelectChangeEvent<string>) => handleChange(e)}
                label="Vendor"
              >
                {vendors.length > 0 ? (
                  vendors.map((vendorId) => (
                    <MenuItem key={vendorId} value={vendorId}>
                      {vendorId}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No vendors available</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid> */}

          <Grid item xs={12} sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={handleCancel} disabled={loading} sx={{ mr: 2 }}>
              Cancel
            </Button>
            <Button type="submit" variant="contained" color="primary" disabled={loading}>
              {loading ? <CircularProgress size={24} /> : 'Create Module'}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default AddModule;
